import type {
  EnvironmentProviders} from '@angular/core';
import {
  APP_INITIALIZER,
  makeEnvironmentProviders,
} from '@angular/core';

import { SloBeaconService } from './slo-beacon.service';
import { ErrorReporter } from './error-reporter';
import { LoggingErrorReporter } from './logging-error-reporter';

/**
 * Arranca el RUM/SloBeacon en el bootstrap y cablea el port de reporte de errores.
 * Va DESPUÉS de config/auth/tenant (los usa para etiquetar los latidos).
 */
export function provideObservability(): EnvironmentProviders {
  return makeEnvironmentProviders([
    // Port de reporte externo. Adapter por defecto = stub gateado por DSN;
    // swappear a @sentry/angular es cambiar sólo este `useClass`.
    { provide: ErrorReporter, useClass: LoggingErrorReporter },
    {
      provide: APP_INITIALIZER,
      useFactory: (beacon: SloBeaconService) => () => beacon.start(),
      deps: [SloBeaconService],
      multi: true,
    },
  ]);
}
